<template>
  <div class="c-mainmenu container" ref="c-mainmenu">
    <div class="h-navi-collapse">
      <ul class="row">
        <li><router-link to="/#app" @click.native="onClick('#app')">WORKS</router-link></li>
        <li><router-link to="/#about" @click.native="onClick('#about')">ABOUT</router-link></li>
        <li><router-link to="/#thought" @click.native="onClick('#title-blog')">THOUGHT</router-link></li>
        <li><router-link to="/#contact" @click.native="onClick('#contact')">CONTACT</router-link></li>
        <li v-if="$route.name === 'detail' || $route.name === 'media'"><router-link class="go-back" to="/">
          <span class="icon icon-link-triangle"></span>
          <p>BACK</p>
        </router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
import Headroom from 'headroom.js'

let headroom = Object

export default {
  data () {
    return {
      isOpen: false
    }
  },
  mounted () {
    const self = this
    const options = {
      onTop: function () {
        self.$store.commit('updateScrollState', false)
      },
      onNotTop: function () {
        self.$store.commit('updateScrollState', true)
      }
    }
    headroom = new Headroom(this.$refs['c-mainmenu'], options)
    headroom.init()
    setTimeout(() => { // remind me
      self.updateCurrentMenu()
    }, 1000)
  },
  methods: {
    onClick (hashtag) {
      this.scrollFix(hashtag)
      this.isOpen = false
    },
    scrollFix: function (hashbang) {
      location.href = hashbang
    },
    toggleNavi () {
      this.isOpen = !this.isOpen
    },
    updateCurrentMenu (id) {
      const anchors = Array.prototype.slice.call(this.$refs['c-mainmenu'].getElementsByTagName('li'))
      anchors.forEach(elm => {
        elm.classList.remove('anchor-current')
      })
      if (id === undefined) {
        if (this.$router.currentRoute.path === '/') {
          anchors[0].classList.add('anchor-current')
        }
      } else {
        this.$refs['c-mainmenu'].querySelectorAll('a[href="/#' + id + '"]')[0].parentNode.classList.add('anchor-current')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MainMenu.vue